'use client'

import { LogOut } from 'lucide-react'

import {
    DropdownMenuItem,
    DropdownMenuShortcut,
} from '@/components/ui/dropdown-menu'
import { signOutUser } from '@/lib/actions/auth.action'

const SignOutMenuItem = () => {
    return (
        <DropdownMenuItem onClick={signOutUser} variant="destructive">
            <LogOut />
            Sign Out
            <DropdownMenuShortcut>Alt+Q</DropdownMenuShortcut>
        </DropdownMenuItem>
    )
}

export default SignOutMenuItem
